<div class="modal-header">
    <h4 class="modal-title">{{ title }}</h4>
</div>
<form name="form" #form="ngForm">
    <div class="modal-body">
        <div class="row">
            <div class="col-sm-12 col-12">
                <div class="form-group">
                    <label for="date">Month/Year</label>
                    <wj-input-date
                        id="date"
                        [(ngModel)]="target.date"
                        name="date"
                        [isRequired]="true"
                        [format]="'MMM yyyy'"
                        [selectionMode]="'Month'"
                    ></wj-input-date>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-12 col-12">
                <div class="form-group">
                    <label for="revenue">Revenue</label>
                    <input type="number" id="revenue" class="form-control" [(ngModel)]="target.revenue" name="revenue" />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-12 col-12">
                <div class="form-group">
                    <label for="profit">Profit / Gross Margin</label>
                    <input type="number" id="profit" class="form-control" [(ngModel)]="target.profit" name="profit" />
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button id="btnSave" type="submit" class="btn btn-primary" (click)="save()" [disabled]="form.invalid || isSaving">
            @if (isSaving) {
                <span><fa-icon [icon]="faSpinner" [animation]="'spin'"></fa-icon>&nbsp;Saving</span>
            } @else {
                <span>Save</span>
            }
        </button>
        <button id="btnCancel" type="button" class="btn btn-secondary" (click)="cancel()" [disabled]="isSaving">Cancel</button>
    </div>
</form>
